import CatalogsService from '@/services/CatalogsService'
import LogService from '@/services/support/LogService'
import { User, UserCatalogFilters, UserStatus } from '@/types/Catalogs'
import { PageRequest } from '@/types/Support'

const LIST_USER = 'listUsers'
const ACTIVE_USERS = 'activeUsers'

export async function getUsersNamesFromLocalStorage (pageRequest: PageRequest<UserCatalogFilters>): Promise<[string[], string[]]> {
  const allUsersNames = localStorage.getItem(LIST_USER)
  const activeUsersNames = localStorage.getItem(ACTIVE_USERS)

  if (allUsersNames === null || activeUsersNames === null) {
    const [allUsersNames, activeUsersNames] = await getUsersAndActiveUsers(pageRequest)
    setUsersAndActiveUsersLocalStorage(allUsersNames, activeUsersNames)
    return [allUsersNames, activeUsersNames]
  } else {
    return [allUsersNames.split(','), activeUsersNames.split(',')]
  }
}

async function getUsersAndActiveUsers (pageRequest: PageRequest<UserCatalogFilters>): Promise<[string[], string[]]> {
  const allUsers = await getAllUsers(pageRequest)

  const allUsersNames = getUserNames(allUsers)
  const activeUsersNames = getUserNames(allUsers.filter(user => user.status !== UserStatus.INACTIVE))

  return [allUsersNames, activeUsersNames]
}

function getUserNames (users: User[]): string[] {
  return users.map(user => user.name)
}

function setUsersAndActiveUsersLocalStorage (usersNames: string[], activeUsersNames: string[]) {
  localStorage.setItem(LIST_USER, usersNames.join(','))
  localStorage.setItem(ACTIVE_USERS, activeUsersNames.join(','))
}

function removeUsersAndActiveUsersLocalStorage () {
  localStorage.removeItem(LIST_USER)
  localStorage.removeItem(ACTIVE_USERS)
}

async function getAllUsers (pageRequest: PageRequest<UserCatalogFilters>): Promise<User[]> {
  const users: User[] = []
  try {
    let response
    do {
      response = await CatalogsService.getUsers(pageRequest)
      pageRequest.page++
      users.push(...response.results)
    } while (users.length < response.total)
    return users
  } catch (error) {
    LogService.error(`Error fetching users: ${error}`)
    return users
  }
}

const localStorageUser = {
  getUsersNamesFromLocalStorage,
  removeUsersAndActiveUsersLocalStorage,
  reloadUsersAndActiveUsers: getUsersAndActiveUsers
}
export default localStorageUser
